
import {
    HashRouter as Router,
    Routes,
    Route,
    Link
  } from "react-router-dom";
  import Home from "./Home";
  import "./App.css";
  import About from "./About";
  import Contact from "./Contact";
  import { useState } from "react";




function App(){  
   const [cartCount, setCartCount] = useState(0);

   const AddToCart = () => {
    setCartCount(cartCount + 1);
   }
//Функция сброса//
   const resetCart = () => {
    setCartCount(0);
  }
  return(
  
    <Router>
    <nav>
    <Link to="/" className="link">Shop</Link>
      <Link to="/about" className="link">About</Link>
      <Link to="/contact" className="link">Contact</Link>

      <div className="cart-container">
            <span className="cart-icon">🛒 {cartCount}</span>
            <button onClick={resetCart} className="btn-reset">Empty Cart</button>
      </div>
    </nav>
    <Routes>
      <Route path="/" element={<Home addFunction={AddToCart}/>} />
      <Route path="/about" element={<About/>}/>
      <Route path="/contact" element={<Contact/>}/>
    </Routes>


    <footer className="site-footer">
        <div className="footer-content">
          <p>© 2026 Modern Wear Store</p>
          <div className="socials">
            <span>Instagram</span> | <span>Facebook</span>
          </div>
        </div>
      </footer>




  </Router>

  )
}
export default App;